import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// Import RxJs required methods



@Injectable()
export class CraneListService {
  private kranAuswahlURL = 'LiftplanII/Kransteuerung/kranauswahl.php';

  constructor(private http: HttpClient) {
  }

  getCraneList(): Promise<Crane[]> {
    const theURL: string = this.kranAuswahlURL + '?action=getListWithInfos';
    const retVal = this.http.get<Crane[]>(theURL).toPromise();
    return retVal;
  }
  getPartsSelectionData(
    datenbankNamen: string,
    Abstuetzverteilung: string,
    rhlradius: string = '0',
    rhllast: string = '0',
    rhlhoehe: string = '0',
    filterObjekt: Object = {}
  ): Promise<Crane> {
    const theURL: string[] = [
      this.kranAuswahlURL + '?action=ladeKran&kranDatenbank=' + datenbankNamen,
      'RHLRadius=' + rhlradius,
      'RHLLast=' + rhllast,
      'RHLHoehe=' + rhlhoehe,
      'Abstuetzverteilung=' + Abstuetzverteilung
    ];
    for (const filter in filterObjekt) {
      if (filterObjekt.hasOwnProperty(filter)) {
        theURL.push(filter + '=' + filterObjekt[filter]);
      }
    }
    const retVal = this.http.get<Crane>(theURL.join('&')).toPromise();
    return retVal;
  }
  getFilteredPartsSelectionData(
    Kombination,
    Identnr,
    Gegengewicht,
    HALaenge,
    HAWinkel,
    HI1Laenge,
    HI1Winkel,
    Abstuetzung,
    Ausfahrfolge,
    Abstuetzverteilung,
    Drehrichtung = '0'
  ): Promise<Crane> {
    const theURL: string[] = [
      this.kranAuswahlURL + '?action=ladeGefilterteRuestzustaende',
      'Kombination=' + Kombination,
      'Identnr=' + Identnr,
      'Gegengewicht=' + Gegengewicht,
      'HALaenge=' + HALaenge,
      'HAWinkel=' + HAWinkel,
      'HI1Laenge=' + HI1Laenge,
      'HI1Winkel=' + HI1Winkel,
      'Abstuetzung=' + Abstuetzung,
      'Ausfahrfolge=' + Ausfahrfolge,
      'Abstuetzverteilung=' + Abstuetzverteilung,
      'Drehrichtung=' + Drehrichtung
    ];
    return this.http.get<Crane>(theURL.join('&')).toPromise();
  }
  holePassendeHALaengeUndAusfahrfolge(HALaenge: string, HAAusfahrf: string): Promise<Object> {
    const theURL: string[] = [
      this.kranAuswahlURL + '?action=holePassendeHALaengeHAAusfahrfolge',
      'HALaenge=' + HALaenge,
      'HAAusfahrf=' + HAAusfahrf
    ];
    return this.http.get(theURL.join('&')).toPromise().catch(this.handleError);
  }
  getKranTabelle(datenbankNamen: string): Promise<Object> {
    const theURL: string = this.kranAuswahlURL + '?action=ladeTabelle&kranDatenbank=' + datenbankNamen;
    return this.http.get(theURL).toPromise().catch(this.handleError);
  }
  getStuetzenDaten(datenbankNamen: string): Promise<Object> {
    const theURL: string = this.kranAuswahlURL + '?action=ladeStuetzen&kranDatenbank=' + datenbankNamen;
    return this.http.get(theURL).toPromise().catch(this.handleError);
  }
  holeRuestdaten(): Promise<Response> {
    const theUrl: string = this.kranAuswahlURL + '?action=holeAktuelleRuestdaten';
    return this.http.get<Response>(theUrl).toPromise();
  }
  //  holeDrehbereiche(Abstuetzung: string): Promise<Response> {
  //    const theUrl: string = this.kranAuswahlURL + '?action=holeDrehbereiche&Abstuetzung=' + Abstuetzung;
  //    return this.http.get(theUrl).map(res => res.json()).toPromise().catch(this.handleError);
  //  }
  spiegleKran() {
    const theURL: string = this.kranAuswahlURL + '?action=spiegleKran';
    this.http.get(theURL).toPromise().catch(this.handleError);
  }
  spiegleKranWennNoetig() {
    const theURL: string = this.kranAuswahlURL + '?action=spiegleKranWennNoetig';
    this.http.get(theURL).toPromise().catch(this.handleError);
  }
  zerstoereKran() {
    const theURL: string = this.kranAuswahlURL + '?action=zerstoereKran';
    this.http.get(theURL).toPromise().catch(this.handleError);
  }
  private handleError(error: Response | any) {
    console.log(error);
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}

export class Crane {
  datenbank: string;
  name: string;
  massSystem: string;
  tabellenTyp: number;
  hersteller: string;
  abstuetzVarianten: number;
  anzahlAbstuetzPositionen: number;
  private _identNummern: number[];
  private _gegengewichte: number[];
  private _abstuetzungen: string[];
  private _haLaengen: number[];
  private _haAusfahrfolgen: string[];

  constructor(
    db: string,
    name: string,
    measuring: string = 'M',
    typ: number = 0,
    manufacturer: string = '',
    outriggerVariants: number = 0,
    outriggerPositions: number = 0
  ) {
    this.datenbank = db;
    this.name = name;
    this.massSystem = measuring;
    this.tabellenTyp = typ;
    this.hersteller = manufacturer;
    this.abstuetzVarianten = outriggerVariants;
    this.anzahlAbstuetzPositionen = outriggerPositions;
  }
  identnummernHinzufuegen(identnr: number) {
    this._identNummern.push(identnr);
  }
  identnummernAusgeben(): number[] {
    return this._identNummern;
  }
  identnummernLeeren() {
    this._identNummern.length = 0;
  }
  gegengewichteHinzufuegen(gegengewicht: number) {
    this._gegengewichte.push(gegengewicht);
  }
  gegengewichteAusgeben(): number[] {
    return this._gegengewichte;
  }
  gegengewichteLeeren() {
    this._gegengewichte.length = 0;
  }
  abstuetzungenHinzufuegen(abstuetzung: string) {
    this._abstuetzungen.push(abstuetzung);
  }
  abstuetzungenAusgeben(): string[] {
    return this._abstuetzungen;
  }
  abstuetzungenLeeren() {
    this._abstuetzungen.length = 0;
  }
  haLaengenHinzufuegen(haLaenge: number) {
    this._haLaengen.push(haLaenge);
  }
  haLaengenAusgeben(): number[] {
    return this._haLaengen;
  }
  haLaengenLeeren() {
    this._haLaengen.length = 0;
  }
  haAusfahrfolgenHinzufuegen(haAusfahrfolgen: string) {
    this._haAusfahrfolgen.push(haAusfahrfolgen);
  }
  haAusfahrfolgenAusgeben(): string[] {
    return this._haAusfahrfolgen;
  }
  haAusfahrfolgenLeeren() {
    this._haAusfahrfolgen.length = 0;
  }
}
